// extracted by mini-css-extract-plugin
export var aboveInput = "_mi-0";
export var actionButton = "_mi-5";
export var actionButtonContainer = "_mi-1";
export var actionIcon = "_mi-6";
export var aiInfoContainer = "_mi-2";
export var attachmentWrapper = "_mi-7";
export var bold = "_mi-3";
export var checkIcon = "_mi-8";
export var clickingRecipientBar = "_mi-11";
export var commentThreadSwitch = "_mi-a";
export var draftImage = "_mi-b";
export var draftImageContainer = "_mi-c";
export var draftImages = "_mi-e";
export var editButton = "_mi-g";
export var editor = "_mi-f";
export var editorContainer = "_mi-y";
export var editorErrorTooltipWrapper = "_mi-9";
export var headerDivider = "_mi-h";
export var icon = "_mi-i";
export var info = "_mi-j";
export var internal = "_mi-n";
export var internalDivider = "_mi-k";
export var internalMessage = "_mi-l";
export var messageInputCard = "_mi-m";
export var messageInputForm = "_mi-o";
export var messageInputFormInternal = "_mi-p";
export var options = "_mi-q";
export var publicMessageCustomer = "_mi-s";
export var publicMessageMerchant = "_mi-r";
export var removeImageButton = "_mi-d";
export var replyButtons = "_mi-t";
export var showSignatureButton = "_mi-u";
export var spinner = "_mi-v";
export var verticalButtonDivider = "_mi-4";
export var visibilitySelector = "_mi-w";
export var warning = "_mi-x";
export var wrappingText = "_mi-z";
export var writingInternalNoteTopBorder = "_mi-10";